import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useQuery, useQueryClient } from "react-query";
import { useEffect } from "react";
import { services } from "../../config";
import { useAuth } from "../../hooks/useAuth";
import { useState } from "react";
import useDebounce, {
  useChosenBackendUrl,
  useCurrencies,
  useIsGovernmentInvexERP,
} from "../../utils/hooks";
import queryString from "query-string";
import CachedIcon from "mdi-react/CachedIcon";
import Expenses from "../Overviews/Expenses";
import Revenue from "../Overviews/Revenue";
import { isEmpty } from "lodash";
import { format } from "date-fns";
import Select from "react-select";
import { analyticsOptions, fetchActionsUtil } from "../../utils/helpers";

import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import "../../assets/scss/customInvoiceWrapper.scss";
import "../../assets/scss/dashboard.scss";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  AmountpaidLegendIcon,
  AmountRemainingLegendIcon,
  InvoiceAmountPaid,
  OverdueInvoicePieChartIcon,
  PaidInvoicePieChartIcon,
  UnpaidInvoicePieChartIcon,
  UpcomingInvoicePieChartIcon,
} from "../Icons";
import { ArcElement } from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
);

export default function InvoiceAnalysisVendorPieChart({
  isStore = false,
  customerId = "",
}) {
  const {
    deploymentCurrencies: currenciesOptions,
    prevailingCurrency,
  } = useCurrencies();
  const {
    user: authUser,
    customerBackendUrl,
    customer,
    authVendor,
  } = useAuth();

  const initialFilterParams = {
    by: "year",
    currency: prevailingCurrency,
    year: new Date().getFullYear(),
    Vendor_ID: authVendor?.Vendor_ID,
  };
  const isGovernmentInvexERP = useIsGovernmentInvexERP();
  const backendUrl = useChosenBackendUrl();
  const [show, setShow] = useState(false);
  const [queryParams, setQueryParams] = useState({
    ...initialFilterParams,
  });
  const debouncedqueryParams = useDebounce(queryParams, 800);

  useEffect(() => {
    setQueryParams({
      ...queryParams,

      Vendor_ID: authVendor?.Vendor_ID,
    });
  }, [customer?.Staff_ID, customerId]);
  const {
    data: stat,
    refetch: refetchStat,
    isLoading,
    isFetching: isFetchingStat,
    isSuccess: isSuccessStat,
    error: errorStat,
  } = useQuery(
    ["FETCH_INVOICE_STATISTICS-PIE_VENDOR", debouncedqueryParams, backendUrl],
    () =>
      fetchActionsUtil(
        `${
          isStore ? customerBackendUrl : backendUrl
        }/api/invoice/invoice-dashboard-vendor-stat?${queryString.stringify(
          debouncedqueryParams,
        )}`,
        "GET",
      ),
    {
      keepPreviousData: true,
      onSuccess: ({ data }) => {},
    },
  );

  //   ["GET_REVENUE", debouncedqueryParams, backendUrl],
  //   () => getRevenue(debouncedqueryParams),
  //   {
  //     // enabled: false,
  //     // cacheTime: 0,
  //     onSuccess: (data) => {

  //       // queryClient.removeQueries("LOGIN");
  //     },
  //   }
  // );

  useEffect(() => {
    console.log(errorStat);
  }, [errorStat]);

  return (
    <div className="custom-chart p-4">
      <header className="section-header  d-flex justify-content-between">
        <h5>
          Invoice Status
          <button
            title="Refresh"
            onClick={() => refetchStat()}
            className="btn text-primary"
          >
            <CachedIcon />
          </button>
        </h5>

        <div className="position-relative z-10">
          <Select
            classNamePrefix={`form-select-analytics`}
            isSearchable={false}
            options={analyticsOptions}
            value={analyticsOptions.find((el) => el.value === queryParams.by)}
            onChange={(selected) => {
              setQueryParams({
                ...queryParams,
                by: selected?.value,
              });
            }}
          />

          {queryParams.by === "select-year" && (
            <div className="position-absolute -bottom-100 end-0 pt-2">
              <Form.Control
                type="number"
                value={queryParams.year}
                onChange={(e) =>
                  setQueryParams({
                    ...queryParams,
                    year: e.target.value,
                  })
                }
                autoFocus={true}
              />
            </div>
          )}
        </div>
      </header>

      {/* bar chart */}

      <div
        className="custom-chart-holder   mt-4 mx-auto my-auto d-flex justify-content-center align-items-center"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div className="pie-holder">
          <Doughnut
            plugins={[ChartDataLabels]}
            data={{
              labels: [
                ...(isSuccessStat
                  ? stat?.data?.piechart.map((el) => el.label)
                  : []),
              ],

              datasets: [
                {
                  data: [
                    ...(isSuccessStat
                      ? stat?.data?.piechart.map((el) => el.count)
                      : []),
                  ],
                  backgroundColor: [
                    //  "#062B68",
                    "#07327A",
                    "#083A8F",
                    "#0A45A9",
                    "#1052C0",
                  ],
                  borderColor: [
                    // "#062B68",
                    "#07327A",
                    "#083A8F",
                    "#0A45A9",
                    "#1052C0",
                  ],
                  borderWidth: 1,
                  hoverOffset: 4,

                  // backgroundColor: [
                  //   "#007aff", // Blue
                  //   "#34c759", // Green
                  //   "#ffcc00", // Yellow
                  //   "#ff3b30", // Red
                  // ],
                  // weight: 1,
                  // clip: 60,
                },
              ], // Replace with your data values
            }}
            options={{
              responsive: true,

              cutout: "60%",
              layout: {
                padding: {
                  left: 24,
                  right: 24,
                  top: 24,
                  bottom: 24,
                },
              },

              plugins: {
                legend: {
                  display: false,
                },
                title: {
                  display: false,
                },
                tooltip: {
                  backgroundColor: "#00000080",
                  boxHeight: 8,
                  boxWidth: 8,
                  pointStyle: "circle",
                  usePointStyle: true,
                  boxPadding: 8,
                },
                datalabels: {
                  align: "end",
                  anchor: "end",
                  fontSize: 12,
                  padding: 4,
                  formatter: function(value, context) {
                    // console.log(value, context.chart.data);
                    let total = context.chart.data.datasets[0].data.reduce(
                      (a, b) => a + b,
                      0,
                    );
                    return `${((value / total) * 100).toFixed(0)}%`;
                  },
                  // hoverColor: "#00000",
                  listeners: {
                    enter: function(context) {
                      // Receives `enter` events for any labels of any dataset. Indices of the
                      // clicked label are: `context.datasetIndex` and `context.dataIndex`.
                      // For example, we can modify keep track of the hovered state and
                      // return `true` to update the label and re-render the chart.
                      context.hovered = true;
                      return true;
                    },
                    leave: function(context) {
                      // Receives `leave` events for any labels of any dataset.
                      context.hovered = false;
                      return true;
                    },
                  },
                  color: function(context) {
                    // Change the label text color based on our new `hovered` context value.
                    return context.hovered ? "#000" : "#94A3B8";
                  },
                },
              },
            }}
          />
          <div className="background_pie" />
        </div>
        {/* <div className="blur" /> */}
      </div>

      {/* <OverviewModal
        show={show}
        setShow={setShow}
        dateRange={
          !isEmpty(data)
            ? {
                startDate: data[0].startDate,
                endDate: data[data.length - 1].endDate,
              }
            : {}
        }
      /> */}
    </div>
  );
}

export function OverviewModal({ show, setShow, dateRange = {} }) {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-block">
          <h2 className="h5 text-nowrap w-100">
            Total Revenue vs Expenses{" "}
            {dateRange?.startDate && dateRange?.endDate ? (
              <span>
                {dateRange.startDate
                  ? format(new Date(dateRange.startDate), "dd MMM, yyy")
                  : ""}
                {" - "}
                {dateRange.endDate
                  ? format(new Date(dateRange.endDate), "dd MMM, yyy")
                  : ""}
              </span>
            ) : null}
          </h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-between">
          <div className="col-md-6  pe-5">
            <Revenue dateRange={dateRange} />
          </div>
          <div className="col-md-6  ps-5">
            <Expenses dateRange={dateRange} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
